module.exports = __webpack_public_path__ + "static/media/2_The inner voice_AF.9a2d5f27.txt";